import { Reveal, Label } from "@/components/motion";
import { EXPERIENCES } from "@/data/site";

export default function HomeExperiences() {
  return (
    <section data-testid="home-experiences" className="border-t border-mist bg-[#F7F7F6]">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <Label>Travel Experiences</Label>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-serif text-4xl font-light leading-[1.0] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                Travel your way.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.15}>
              <p className="text-base leading-relaxed text-steel">
                Four ways we shape journeys — always beginning with how you like to
                travel.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 grid gap-x-10 gap-y-16 sm:grid-cols-2">
          {EXPERIENCES.map((exp, i) => (
            <Reveal key={exp.title} delay={(i % 2) * 0.12} className={i % 2 === 1 ? "lg:mt-24" : ""}>
              <div data-testid={`experience-${i}`} className="group">
                <div className={`overflow-hidden ${i % 2 === 0 ? "aspect-[16/11]" : "aspect-[4/5]"}`}>
                  <img
                    src={exp.image}
                    alt={exp.title}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
                  />
                </div>
                <div className="mt-7 flex items-baseline gap-5">
                  <span className="font-serif text-2xl font-light text-gold">0{i + 1}</span>
                  <div>
                    <h3 className="font-serif text-2xl font-light tracking-tight text-ink sm:text-3xl">
                      {exp.title}
                    </h3>
                    <p className="mt-2 max-w-sm text-[15px] leading-relaxed text-steel">{exp.text}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
